import React, { useState } from "react";
import { Link, Outlet, useNavigate } from "react-router-dom";
import { Grid, List, ListItem, Typography, Dialog, DialogTitle, DialogContent, DialogActions, Button } from "@mui/material";
import "../../Styles/Layouts/common_sidebar.css";
import { useLocation } from "react-router-dom";
import logo from "../../Assets/logo.svg";

const Superadmin_sidebar = () => {
  const location = useLocation();
  const navigate = useNavigate();

  //destructuring pathname from location
  const { pathname } = location;
  const [openLogoutModal, setOpenLogoutModal] = useState(false);

  const handleLogoutOpen = () => setOpenLogoutModal(true);
  const handleLogoutClose = () => setOpenLogoutModal(false);

  const handleLogout = () => {
    // Remove the token from local storage
    localStorage.removeItem("token");
    localStorage.removeItem("role");
    navigate("/superadmin");
    window.location.reload();
  };

  //Javascript split method to get the name of the path in array
  const splitLocation = pathname.split("/");
  return (
    <React.Fragment>
      <Grid sx={{ width: "100%" }} container spacing={2}>
        <Grid sx={{ width: "17%" }} item>
          <div className="sidebar-content">
            <div className="main-logo">
              <img src={logo} alt="logo" />
            </div>
            <List>
              <Link to="/superadmin/Dashboard">
                <ListItem
                  className={
                    splitLocation[1] === "superadmin" &&
                      splitLocation[2] === "Dashboard"
                      ? "active"
                      : ""
                  }
                >
                  Dashboard
                </ListItem>
              </Link>
              <Link to="/superadmin/Vendors">
                <ListItem
                  className={
                    (splitLocation[1] === "superadmin" &&
                      splitLocation[2] === "Vendors") ||
                      (splitLocation[1] === "superadmin" &&
                        splitLocation[2] === "ActiveFieldOfficers") ||
                      (splitLocation[1] === "superadmin" &&
                        splitLocation[2] === "InactiveFieldOfficers") ||
                      (splitLocation[1] === "superadmin" &&
                        splitLocation[2] === "Fields") ||
                      (splitLocation[1] === "superadmin" &&
                        splitLocation[2] === "FieldDetails") ||
                      (splitLocation[1] === "superadmin" &&
                        splitLocation[2] === "AllDetails") ||
                      (splitLocation[1] === "superadmin" &&
                        splitLocation[2] === "StatusFieldOfficers")
                      ? "active"
                      : ""
                  }
                >
                  Vendors
                </ListItem>
              </Link>
            </List>
            <div className="logout-btn">
              <button className="logout" color="error" onClick={handleLogoutOpen}>
                Logout
              </button>
            </div>
          </div>
        </Grid>
        <Grid sx={{ width: "83%" }} item>
          <Outlet />
        </Grid>
      </Grid>

      <Dialog
        open={openLogoutModal}
        onClose={handleLogoutClose}
        aria-labelledby="logout-dialog-title"
        PaperProps={{
          sx: {
            borderRadius: "12px",
            padding: "10px",
            minWidth: "400px",
            width: "400px"
          }
        }}
      >
        <DialogTitle id="logout-dialog-title" sx={{ fontFamily: "Poppins, sans-serif", fontWeight: "bold", fontSize: "1.25rem" }}>
          Logout Confirmation
        </DialogTitle>
        <DialogContent sx={{ mt: 1 }}>
          <Typography sx={{ fontFamily: "Poppins, sans-serif", color: "#555" }}>
            Are you sure you want to logout?
          </Typography>
        </DialogContent>
        <DialogActions sx={{ padding: "16px 24px", gap: 1 }}>
          <Button
            onClick={handleLogoutClose}
            sx={{
              color: "#666",
              textTransform: "none",
              fontFamily: "Poppins, sans-serif",
              fontWeight: 500
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleLogout}
            variant="contained"
            sx={{
              bgcolor: "#79c245",
              color: "#fff",
              textTransform: "none",
              fontFamily: "Poppins, sans-serif",
              fontWeight: 600,
              boxShadow: "none",
              borderRadius: "8px",
              padding: "8px 24px",
              "&:hover": {
                bgcolor: "#68a63b",
                boxShadow: "0 4px 12px rgba(121, 194, 69, 0.3)"
              }
            }}
          >
            Yes, Logout
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};

export default Superadmin_sidebar;
